var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsFileChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 146,
    height: 145,
    viewBox: "0 0 146 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6369",
    "data-name": "Rectangle 6369",
    width: 146,
    height: 145,
    transform: "translate(1076.304 287.992)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_15639",
    x: 15.221,
    y: 10.707,
    width: 99.864,
    height: 114.582,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_15639-2",
    x: 32.918,
    y: 22.452,
    width: 80.443,
    height: 101.257,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_701",
    x: 74.689,
    y: 87,
    width: 50,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#44580a",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(-1076.304 -287.992)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18891",
    "data-name": "Group 18891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18425",
    "data-name": "Group 18425",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 1100.524, 320.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18420",
    "data-name": "Group 18420",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97, 0.26, -0.26, 0.97, -14.89, -38.02)",
    filter: "url(#Path_15639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15639-3",
    "data-name": "Path 15639",
    transform: "matrix(0.97, -0.26, 0.26, 0.97, 24.22, 32.87)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58.55012512207031 82.75728607177734 L 58.54026794433594 82.75728607177734 L 3.883157253265381 82.75728607177734 C 2.018246173858643 82.75258636474609 0.5000016093254089 81.23056030273438 0.5000016093254089 79.36444091796875 L 0.5000016093254089 79.35459136962891 L 0.5000016093254089 3.883150339126587 C 0.5047016143798828 2.018239259719849 2.026723861694336 0.5000059008598328 3.89284610748291 0.5000059008598328 L 3.902690410614014 0.5000059008598328 L 41.12863540649414 0.5000059008598328 L 41.12863540649414 18.21252822875977 C 41.12863540649414 19.92286109924316 42.52010345458984 21.31431770324707 44.23043441772461 21.31431770324707 L 61.94295883178711 21.31431770324707 L 61.94295883178711 79.37413024902344 C 61.93825531005859 81.23903656005859 60.41623687744141 82.75728607177734 58.55012512207031 82.75728607177734 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.892833709716797 0.9999923706054688 C 2.301723480224609 0.9999923706054688 1.004001617431641 2.294502258300781 1 3.883148193359375 L 1 79.36444091796875 C 1 80.95555114746094 2.294502258300781 82.25327301025391 3.883144378662109 82.25727081298828 L 58.55012512207031 82.25727081298828 C 60.1412353515625 82.25727081298828 61.43895721435547 80.96276092529297 61.44295883178711 79.37411499023438 L 61.44295883178711 21.81431579589844 L 44.23043441772461 21.81431579589844 C 42.24439239501953 21.81431579589844 40.62863540649414 20.19856262207031 40.62863540649414 18.2125244140625 L 40.62863540649414 0.9999923706054688 L 3.892833709716797 0.9999923706054688 M 3.892833709716797 -7.62939453125e-06 L 41.62863540649414 -7.62939453125e-06 L 41.62863540649414 18.2125244140625 C 41.62863540649414 19.64872741699219 42.79423522949219 20.81431579589844 44.23043441772461 20.81431579589844 L 62.44295883178711 20.81431579589844 L 62.44295883178711 79.37411499023438 C 62.43755722045898 81.51761627197266 60.69361114501953 83.25727081298828 58.55012512207031 83.25727081298828 L 3.883144378662109 83.25727081298828 C 1.739658355712891 83.25186920166016 0 81.50792694091797 0 79.36444091796875 L 0 3.883148193359375 C 0.005401611328125 1.739646911621094 1.749347686767578 -7.62939453125e-06 3.892833709716797 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18423",
    "data-name": "Group 18423",
    transform: "translate(14.522 36.395)",
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6281",
    "data-name": "Rectangle 6281",
    width: 10.891,
    height: 21.782,
    transform: "translate(0.726 1.452)",
    fill: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6277",
    "data-name": "Rectangle 6277",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#dadadc",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.126,
    height: 23.961,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32.126,
    height: 21.961,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6278",
    "data-name": "Rectangle 6278",
    width: 33.4,
    height: 1.452,
    transform: "translate(0.726 7.261)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6279",
    "data-name": "Rectangle 6279",
    width: 33.4,
    height: 1.452,
    transform: "translate(0.726 15.248)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6280",
    "data-name": "Rectangle 6280",
    width: 1.452,
    height: 23.961,
    transform: "translate(10.165 0)",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_15640",
    "data-name": "Path 15640",
    transform: "translate(41.628 0)",
    fill: "#dadadc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.31432151794434 20.31431770324707 L 2.601791620254517 20.31431770324707 C 1.442861676216125 20.31431770324707 0.5000017285346985 19.37145805358887 0.5000017285346985 18.21252822875977 L 0.5000017285346985 0.4999978840351105 L 0.99187171459198 0.4999978840351105 L 1.001561760902405 0.4999978840351105 C 1.763721704483032 0.4999978840351105 2.863581657409668 0.9544678926467896 3.40330171585083 1.492407917976379 L 19.32231140136719 17.4276180267334 C 19.86012077331543 17.96542739868164 20.31432151794434 19.06196784973145 20.31432151794434 19.82228851318359 L 20.31432151794434 20.31431770324707 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.81430053710938 19.81431770324707 C 19.81092643737793 19.18834686279297 19.40951728820801 18.22193336486816 18.96857261657715 17.78099822998047 L 3.050331830978394 1.846547842025757 C 2.605811595916748 1.403497934341431 1.62930166721344 0.9999979138374329 1.001561760902405 0.9999979138374329 L 1.000001668930054 0.9999979138374329 L 1.000001668930054 18.21252822875977 C 1.000001668930054 19.09575843811035 1.718561768531799 19.81431770324707 2.601791620254517 19.81431770324707 L 19.81430053710938 19.81431770324707 M 20.81432151794434 20.81431770324707 L 2.601791620254517 20.81431770324707 C 1.165591716766357 20.81431770324707 1.712646508167381e-06 19.64872741699219 1.712646508167381e-06 18.21252822875977 L 1.712646508167381e-06 -2.102050757457619e-06 L 1.001561760902405 -2.102050757457619e-06 C 1.891631722450256 -2.102050757457619e-06 3.125831604003906 0.5099079012870789 3.756271600723267 1.138277888298035 L 19.6760425567627 17.07424736022949 C 20.30441093444824 17.70261764526367 20.81432151794434 18.93379783630371 20.81432151794434 19.82228851318359 L 20.81432151794434 20.81431770324707 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18424",
    "data-name": "Group 18424",
    transform: "translate(1118.222 316.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18420-2",
    "data-name": "Group 18420",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -41.92, -28.45)",
    filter: "url(#Path_15639-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15639-4",
    "data-name": "Path 15639",
    transform: "translate(41.92 111.58)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 58.55012512207031 -0.3675141632556915 L 58.54026794433594 -0.3675141632556915 L 3.883157253265381 -0.3675141632556915 C 2.018246173858643 -0.3722141683101654 0.5000016093254089 -1.894236326217651 0.5000016093254089 -3.760358572006226 L 0.5000016093254089 -3.770203113555908 L 0.5000016093254089 -79.24164581298828 C 0.5047016143798828 -81.10655975341797 2.026723861694336 -82.62479400634766 3.89284610748291 -82.62479400634766 L 3.902690410614014 -82.62479400634766 L 41.12863540649414 -82.62479400634766 L 41.12863540649414 -64.91226959228516 C 41.12863540649414 -63.20193481445312 42.52010345458984 -61.81048202514648 44.23043441772461 -61.81048202514648 L 61.94295883178711 -61.81048202514648 L 61.94295883178711 -3.750669717788696 C 61.93825531005859 -1.885758638381958 60.41623687744141 -0.3675141632556915 58.55012512207031 -0.3675141632556915 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.892833709716797 -82.12479400634766 C 2.301723480224609 -82.12479400634766 1.004001617431641 -80.83029174804688 1 -79.24164581298828 L 1 -3.760360717773438 C 1 -2.16925048828125 2.294502258300781 -0.8715286254882812 3.883144378662109 -0.867523193359375 L 58.55012512207031 -0.867523193359375 C 60.1412353515625 -0.867523193359375 61.43895721435547 -2.162025451660156 61.44295883178711 -3.75067138671875 L 61.44295883178711 -61.31047821044922 L 44.23043441772461 -61.31047821044922 C 42.24439239501953 -61.31047821044922 40.62863540649414 -62.92623901367188 40.62863540649414 -64.91226959228516 L 40.62863540649414 -82.12479400634766 L 3.892833709716797 -82.12479400634766 M 3.892833709716797 -83.12479400634766 L 41.62863540649414 -83.12479400634766 L 41.62863540649414 -64.91226959228516 C 41.62863540649414 -63.47607040405273 42.79423522949219 -62.31047821044922 44.23043441772461 -62.31047821044922 L 62.44295883178711 -62.31047821044922 L 62.44295883178711 -3.75067138671875 C 62.43755722045898 -1.607192993164062 60.69361114501953 0.132476806640625 58.55012512207031 0.132476806640625 L 3.883144378662109 0.132476806640625 C 1.739658355712891 0.1270828247070312 0 -1.616867065429688 0 -3.760360717773438 L 0 -79.24164581298828 C 0.005401611328125 -81.38513946533203 1.749347686767578 -83.12479400634766 3.892833709716797 -83.12479400634766 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18423-2",
    "data-name": "Group 18423",
    transform: "translate(14.522 33.49)",
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6281-2",
    "data-name": "Rectangle 6281",
    width: 11,
    height: 22,
    transform: "translate(0.249 9.057)",
    fill: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6277-2",
    "data-name": "Rectangle 6277",
    transform: "translate(0.249 0.057)",
    fill: "none",
    stroke: "#dadadc",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 32,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 30,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6278-2",
    "data-name": "Rectangle 6278",
    width: 34,
    height: 2,
    transform: "translate(0.249 15.057)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6282",
    "data-name": "Rectangle 6282",
    width: 34,
    height: 2,
    transform: "translate(0.249 7.057)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6279-2",
    "data-name": "Rectangle 6279",
    width: 34,
    height: 2,
    transform: "translate(0.249 23.057)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6280-2",
    "data-name": "Rectangle 6280",
    width: 1,
    height: 24,
    transform: "translate(10.249 8.057)",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_15640-2",
    "data-name": "Path 15640",
    transform: "translate(-5.872 83.125)",
    fill: "#dadadc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67.81421661376953 -62.81047439575195 L 50.1016731262207 -62.81047439575195 C 48.94274520874023 -62.81047439575195 47.99988174438477 -63.75333786010742 47.99988174438477 -64.91226959228516 L 47.99988174438477 -82.62479400634766 L 48.49175262451172 -82.62479400634766 L 48.50144195556641 -82.62479400634766 C 49.26360321044922 -82.62479400634766 50.36346435546875 -82.17032623291016 50.90318298339844 -81.63238525390625 L 66.82219696044922 -65.69717407226562 C 67.36000061035156 -65.15935516357422 67.81421661376953 -64.06281280517578 67.81421661376953 -63.30250549316406 L 67.81421661376953 -62.81047439575195 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67.31419372558594 -63.31047439575195 C 67.31082153320312 -63.93643569946289 66.90940093994141 -64.90284729003906 66.46845245361328 -65.34379577636719 L 50.55021286010742 -81.27824401855469 C 50.10569381713867 -81.72129821777344 49.12918472290039 -82.12479400634766 48.50144195556641 -82.12479400634766 L 48.49988174438477 -82.12479400634766 L 48.49988174438477 -64.91226959228516 C 48.49988174438477 -64.02903747558594 49.21844482421875 -63.31047439575195 50.1016731262207 -63.31047439575195 L 67.31419372558594 -63.31047439575195 M 68.31421661376953 -62.31047439575195 L 50.1016731262207 -62.31047439575195 C 48.66547393798828 -62.31047439575195 47.49988174438477 -63.47606658935547 47.49988174438477 -64.91226959228516 L 47.49988174438477 -83.12479400634766 L 48.50144195556641 -83.12479400634766 C 49.39151382446289 -83.12479400634766 50.62571334838867 -82.61488342285156 51.25615310668945 -81.98651885986328 L 67.17592620849609 -66.05054473876953 C 67.80429077148438 -65.42217254638672 68.31421661376953 -64.19099426269531 68.31421661376953 -63.30250549316406 L 68.31421661376953 -62.31047439575195 Z",
    stroke: "none",
    fill: "#dadadc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18422",
    "data-name": "Group 18422",
    transform: "translate(1160.335 381.156)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -84.03, -93.16)",
    filter: "url(#Ellipse_701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_701-2",
    "data-name": "Ellipse 701",
    transform: "translate(83.69 93)",
    fill: "#8bb611",
    stroke: "rgba(0,0,0,0.06)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 15.5,
    rx: 16,
    ry: 15.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 15.5,
    rx: 15.5,
    ry: 15,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15763",
    "data-name": "Path 15763",
    d: "M5.434-.269a.8.8,0,0,0,1.131,0l9.2-9.2a.8.8,0,0,0,0-1.131l-1.131-1.131a.8.8,0,0,0-1.131,0L6-4.228l-3.5-3.5a.8.8,0,0,0-1.131,0L.234-6.6a.8.8,0,0,0,0,1.131Z",
    transform: "translate(7.969 21.836)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsFileChecked);
export default __webpack_public_path__ + "static/media/xls-file-checked.b2c2e2759f0853a6499b82ca84cedcb9.svg";
export { ForwardRef as ReactComponent };